import Helpers from "./helpers";

export default class FilterSlideOut {

	private allow = true;
	private overlayElement = document.querySelector('.js-filter-slide-overlay') as HTMLElement;
	private topElement = document.querySelector('#top') as HTMLElement;
	private slideOutElement = document.querySelector('.js-filter-slide-out');

	constructor() {

		if (!this.slideOutElement) {
			return;
		}

		this.attachEvents();
		this.slideOutElement.classList.add('js-filter-slide-out-done');
	}

	private attachEvents() {
		document.addEventListener('click', (event: any) => {
			if (event.target.matches('.js-filter-slide-close') ||
				event.target.matches('.js-filter-slide-overlay')) {
				this.closeSlideOut(event);
			}
			if (event.target.matches('.js-filter-slide-title')) {
				this.showSlideOut(event);
			}
		}, false);

		const debouncedSetHeights = Helpers.debounce(() => this.resizeCheck(), 500);
		window.addEventListener('resize', debouncedSetHeights);
	}

	private resizeCheck() {
		if (window.matchMedia('(min-width: 980px)').matches) {
			this.updateDOMToCloseSlideOut();
		}
	}

	private showSlideOut(event: Event) {
		event.preventDefault();
		if (!this.allow) return false;
		this.allow = false;
		Helpers.deferTask(() => {
			this.updateDOMToShowSlideOut();
			setTimeout(() => { this.allow = true; }, 300);
		});
	}

	private updateDOMToShowSlideOut() {
		this.slideOutElement.classList.add('active');
		this.overlayElement.classList.add('is-active');
		this.topElement.style.overflow = 'hidden';
		document.documentElement.classList.add('filter-slide-out-active');
	}

	private closeSlideOut(event: Event) {
		event.preventDefault();
		if (!this.allow) return false;
		this.allow = false;
		Helpers.deferTask(() => {
			this.updateDOMToCloseSlideOut();
			setTimeout(() => { this.allow = true; }, 300);
		});
	}

	private updateDOMToCloseSlideOut() {
		this.slideOutElement.classList.remove('active');
		this.overlayElement.classList.remove('is-active');
		this.topElement.style.removeProperty('overflow');
		document.documentElement.classList.remove('filter-slide-out-active');
	}

}
